var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgTrash = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9601 3.13361H9.60068V2.81329C9.60068 2.46017 9.31475 2.17267 8.96006 2.17267H7.03975C6.68662 2.17267 6.39912 2.45861 6.39912 2.81329V3.13361H3.03975C2.95068 3.13361 2.88037 3.20548 2.88037 3.29298V4.25236C2.88037 4.34142 2.95225 4.41173 3.03975 4.41173H3.51943L4.16006 12.732C4.16006 13.0836 4.28506 13.3852 4.53662 13.6367C4.78662 13.8867 5.08818 14.0117 5.43975 14.0117H10.5601C10.9116 14.0117 11.2132 13.8867 11.4647 13.6367C11.7147 13.3852 11.8397 13.0836 11.8397 12.732L12.4804 4.41173H12.9601C13.0491 4.41173 13.1194 4.33986 13.1194 4.25236V3.29298C13.1194 3.20548 13.0476 3.13361 12.9601 3.13361ZM7.03975 11.4539H6.08037V5.69454H7.03975V11.4539ZM9.91943 11.4539H8.96006V5.69454H9.91943V11.4539Z",
    fill: "#8D8D8D"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTrash, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/trash.7f6d3ac3.svg";
export { ForwardRef as ReactComponent };